// import { DefaultTable } from '../Components/DefaultTable';
import { COLUMNS } from './Column';
// import { SellTableData } from './Data';
import { LoadingMode } from '../Components/LoadingMode';
// import OfferDetails from './OfferDetails';
import SellOfferData from './SellOfferData';
import { Table } from './Table';
import { BuyandSellOfferTableModals } from './BuyandSellOfferTableModals';

export const SellTable = () => {
  const {
    sellOfferDataArray,
    handleOpenandCloseModal,
    offerDetails,
    cxId,
    openModal,
  } = SellOfferData();

  return (
    <div>
      {sellOfferDataArray.length === 0 ? (
        // <LoadingMode />
        <div className="w-full">
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-lg text-center">No data available</p>
          </div>
        </div>
      ) : (
        <Table columns={COLUMNS} data={sellOfferDataArray} />
      )}
      <BuyandSellOfferTableModals
        openModal={openModal}
        handleOpenandCloseModal={handleOpenandCloseModal}
        offerDetails={offerDetails}
        cxId={cxId}
      />
    </div>
  );
};
